<template>
  <scale-text-field
    class="textfield"
    type="text"
    :value="value"
    @input="updateValue"
    :label="label"
    :placeholder="placeholder"
    :helper-text="helperText"
    :invalid="invalid"
    :max-length="maxLength"
    :counter="counter"
    :readonly="readonly"
  >
    <slot name="tooltip-info"></slot>
  </scale-text-field>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  value: String,
  label: { type: String, required: true },
  placeholder: { type: String, required: false, default: "" },
  helperText: { type: String, required: false, default: "" },
  invalid: { type: Boolean, required: false, default: false },
  maxLength: { type: Number, required: false },
  counter: { type: Boolean, required: false, default: false },
  readonly: { type: Boolean, required: false, default: false },
});

const emit = defineEmits(['input']);

function updateValue(event) {
  emit('input', event.target.value);
}
</script>

<style lang="scss" scoped>
.textfield {
  position: relative;
  display: block;
}
.tooltip {
  position: absolute;
  z-index: 2;
  right: 8px;
  top: 8px;
}
.tooltip-icon:hover {
  cursor: pointer;
  path {
    fill: #b8b8ba;
  }
}
</style>
